<script setup lang="ts">
import MediaSelectPopup from "@/components/mobile/media/MediaSelectPopup.vue";
import api from "@/modules/api";
import { MediaUploadFileItem } from "@/types/component";
import {
  showDialog,
  showFailToast,
  showImagePreview,
  showLoadingToast,
} from "vant";
import { ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const showMediaSelectPopup = ref(false);
const selectedMedia = ref<MediaUploadFileItem | null>(null);

const handleMediaSelected = (mediaList: MediaUploadFileItem[]) => {
  selectedMedia.value = mediaList[0];
};

const handleSubmit = async () => {
  if (!selectedMedia.value) {
    showFailToast("请上传截图");
    return;
  }
  const loading = showLoadingToast("提交中...");
  try {
    await api.createOneUserShareReward({
      imageMediaId: selectedMedia.value!.mediaId!,
    });
    loading.close();
    await showDialog({
      title: "提交成功",
      message: "感谢您的分享，审核通过后，您将获得能量块奖励",
      showCancelButton: false,
      showConfirmButton: true,
    });
    router.back();
  } catch (error) {
    loading.close();
    showFailToast("提交失败");
  }
};
const showSampleNote = () => {
  showImagePreview(["/img/share-xhs-sample.jpg"]);
};
</script>
<template>
  <div class="w-full grid grid-rows-[auto_1fr_auto] h-full overflow-hidden">
    <ThreadsNav :show-center="false" show-back />
    <div class="h-full flex flex-col justify-between px-5 overflow-y-auto">
      <div class="flex flex-col gap-4 justify-center items-center">
        <div
          class="text-base font-bold w-full text-center flex items-center gap-1 justify-center"
        >
          发布使用心得笔记，最多获取 <PowerIcon />100！
        </div>
        <div class="text-base-content/80 w-full">
          1.发布小红书笔记，分享你使用饼次元的心得体会或你觉得最赞的功能点（字数不限，真情实感最重要哦！）
        </div>
        <div class="text-base-content/80 w-full">
          2.记得在笔记中带上话题
          <span class="text-primary">#oc #OC #oc创作 #ocapp推荐 #饼次元</span>
        </div>
        <div class="text-base-content/80 w-full">
          3.对笔记页进行截图，要可看到您的小红书账号名称和笔记标题，让我们的审核人员可搜索到您的笔记。
        </div>
        <div
          class="w-full bg-base-300 rounded-lg flex justify-center items-center min-h-24"
        >
          <button
            v-if="!selectedMedia"
            class="btn btn-primary btn-xs rounded"
            @click="showMediaSelectPopup = true"
          >
            <i class="iconify mingcute--upload-line"></i>
            上传小红书笔记截图
          </button>
          <div
            v-else
            class="w-full h-full"
            @click="showMediaSelectPopup = true"
          >
            <img
              :src="selectedMedia?.url"
              class="w-full h-full"
              crossorigin="anonymous"
            />
          </div>
        </div>
        <div class="text-center text-base-content/80">
          如有任何问题，可加入QQ群：795055136 咨询工作人员
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-2 p-8 pt-4">
      <button class="rounded btn btn-sm" @click="showSampleNote">
        查看截图样例
      </button>
      <button class="rounded btn btn-sm btn-primary" @click="handleSubmit">
        提交笔记截图
      </button>
    </div>
    <MediaSelectPopup
      v-model:show="showMediaSelectPopup"
      :media-type="'img'"
      :multiple="false"
      :upload-type="0"
      :enable-mate-gallery="false"
      :enable-image-gen-gallery="false"
      :enable-module-gallery="false"
      :enable-go-image-gen="false"
      :enable-use-avatar="false"
      :enable-mate-wish="false"
      :enable-draw="false"
      :enable-crop="false"
      replace
      @on-media-selected="handleMediaSelected"
    />
  </div>
</template>
